const getters = {
  sidebarColors: state => state.sidebarColors,
  bodyColors: state => state.bodyColers,
  cardColors: state => state.cardColors,
  footerColors: state => state.footerColors,
  headerColors: state => state.headerColors
};

export default getters;
